export interface Calendar {
    data: any,
    loading: boolean,
    error: string,
    events: [],
    userData: any
}

export interface EvenTypes {
    createdAt: string,
    createdBy: string,
    deletedAt: string,
    id: string,
    updatedAt: string,
    valuesJson: string
  }

export enum CalendarActionTypes {

    POST_GOOGLECALENDARSYNC_REQUEST = "@@calendar/POST_GOOGLECALENDARSYNC_REQUEST",
    POST_GOOGLECALENDARSYNC_SUCCESS = "@@calendar/POST_GOOGLECALENDARSYNC_SUCCESS",
    POST_GOOGLECALENDARSYNC_ERROR = "@@calendar/POST_GOOGLECALENDARSYNC_ERROR",
    GET_GOOGLECALENDARSYNC_REQUEST = "@@calendar/GET_GOOGLECALENDARSYNC_REQUEST",
    GET_GOOGLECALENDARSYNC_SUCCESS = "@@calendar/GET_GOOGLECALENDARSYNC_SUCCESS",
    GET_GOOGLECALENDARSYNC_ERROR = "@@calendar/GET_GOOGLECALENDARSYNC_ERROR",
    DELETE_GOOGLECALENDARSYNC_REQUEST = "@@calendar/DELETE_GOOGLECALENDARSYNC_REQUEST",
    DELETE_GOOGLECALENDARSYNC_SUCCESS = "@@calendar/DELETE_GOOGLECALENDARSYNC_SUCCESS",
    DELETE_GOOGLECALENDARSYNC_ERROR = "@@calendar/DELETE_GOOGLECALENDARSYNC_ERROR",
    GET_GOOGLECALENDAREVENTS_REQUEST = "@@calendar/GET_GOOGLECALENDAREVENTS_REQUEST",
    GET_GOOGLECALENDAREVENTS_SUCCESS = "@@calendar/GET_GOOGLECALENDAREVENTS_SUCCESS",
    GET_GOOGLECALENDAREVENTS_ERROR = "@@calendar/GET_GOOGLECALENDAREVENTS_ERROR",
    POST_CREATEGOOGLEEVENT_SUCCESS = "@@calendar/POST_CREATEGOOGLEEVENT_SUCCESS",
    POST_CREATEGOOGLEEVENT_REQUEST = "@@calendar/POST_CREATEGOOGLEEVENT_REQUEST",
    POST_CREATEGOOGLEEVENT_ERROR = "@@calendar/POST_CREATEGOOGLEEVENT_ERROR",
    DELETE_GOOGLECALENDAREVENT_SUCCESS = "@@calendar/DELETE_GOOGLECALENDAREVENT_SUCCESS",
    DELETE_GOOGLECALENDAREVENT_REQUEST = "@@calendar/DELETE_GOOGLECALENDAREVENT_REQUEST",
    DELETE_GOOGLECALENDAREVENT_ERROR = "@@calendar/DELETE_GOOGLECALENDAREVENT_ERROR",
    SIGNUP_MICROSOFT_REQUEST = '@@calendar/SIGNUP_MICROSOFT_REQUEST',
    SIGNUP_MICROSOFT_SUCCESS = '@@calendar/SIGNUP_MICROSOFT_SUCCESS',
    SIGNUP_MICROSOFT_ERROR = '@@calendar/SIGNUP_MICROSOFT_ERROR',
    GET_EVENTTYPEMETADATA_REQUEST = '@@calendar/GET_EVENTTYPEMETADATA_REQUEST',
    GET_EVENTTYPEMETADATA_SUCCESS = '@@calendar/GET_EVENTTYPEMETADATA_SUCCESS',
    GET_EVENTTYPEMETADATA_ERROR = '@@calendar/GET_EVENTTYPEMETADATA_ERROR',
    POST_EVENT_TYPE_REQUEST = '@@calendar/POST_EVENT_TYPE_REQUEST',
    POST_EVENT_TYPE_SUCCESS = '@@calendar/POST_EVENT_TYPE_SUCCESS',
    POST_EVENT_TYPE_ERROR = '@@calendar/POST_EVENT_TYPE_ERROR',
    GET_EVENT_TYPE_REQUEST = '@@calendar/GET_EVENT_TYPE_REQUEST',
    GET_EVENT_TYPE_SUCCESS = '@@calendar/GET_EVENT_TYPE_SUCCESS',
    GET_EVENT_TYPE_ERROR = '@@calendar/GET_EVENT_TYPE_ERROR',
    DELETE_EVENT_TYPE_REQUEST = '@@calendar/DELETE_EVENT_TYPE_REQUEST',
    DELETE_EVENT_TYPE_SUCCESS = '@@calendar/DELETE_EVENT_TYPE_SUCCESS',
    DELETE_EVENT_TYPE_ERROR = '@@calendar/DELETE_EVENT_TYPE_ERROR',


}

export interface CalendarState {
    readonly data?: any;
    readonly loading: boolean;
    readonly error: string | null;
    readonly events: [] | null;
    readonly token: string;
    readonly userData: any;
    readonly metaDataFields: any;
    readonly metaLoading: boolean;
      readonly list: EvenTypes[] | null;
}